import axios from 'axios'

// Post Data
export default axios.create({
    responseType: 'json',
    baseUrl: window.location.origin,
    method: 'post',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': window.csrfTokenValue,
        'X-Requested-With': 'XMLHttpRequest'
    },
    transformRequest: [
        (formData) => {
            formData.append("action", "quotation/quotation-form/get-vehicle-api-data")
            formData.append(window.csrfTokenName, window.csrfTokenValue)
            return formData
        }
    ]
})